import BillingOutcomeLayout from "@/domains/billing/components/BillingOutcomeLayout";

const BillingCancelPage = () => {
  return (
    <BillingOutcomeLayout
      status="cancel"
      eyebrow="Checkout canceled"
      title="Checkout canceled"
      description="No charge was made. Your current account access stays exactly as it was."
      detail="You can restart checkout anytime from the dashboard when you are ready."
      ctaLabel="Return to dashboard"
      ctaTo="/portal"
      secondaryTo="/"
    />
  );
};

export default BillingCancelPage;
